export default __webpack_public_path__ + "static/media/apple-juice-menu-bg.fa43e018.png";